import { render, staticRenderFns } from "./onSale.vue?vue&type=template&id=70f78434&scoped=true&"
import script from "./onSale.vue?vue&type=script&lang=js&"
export * from "./onSale.vue?vue&type=script&lang=js&"
import style0 from "./onSale.vue?vue&type=style&index=0&id=70f78434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f78434",
  null
  
)

component.options.__file = "onSale.vue"
export default component.exports